<div class="account-section">
  <div class="my-section-box">
    @if (true) {
      <form [formGroup]="replacementCostForm">
        <div class="my-section-box__headline">{{ 'common.value_calculator_replacement_cost_title' | cxTranslate }}</div>
        <div class="my-section-box replacementCost" id="replacementCost">
          <div class="my-section-box-inner fleet-info-block">
            <div class="row">
              <div class="col-12 col-xs-12 col-sm-6 col-md-6 col-lg-6">
                <label class="form-label" for="replacementFleetCostPerActuator">
                {{ 'common.value_calculator_replacementFleetCostPerActuator' | cxTranslate }}*</label>
                <div class="row col-12">
                  <div class="col-8 col-sm-6 pr-0 pl-0">
                    <input type="number" formControlName="replacementFleetCostPerActuator"
                      (keypress)="calculateAndSetSum()" />
                      @if (form.replacementFleetCostPerActuator.invalid && (form.replacementFleetCostPerActuator.dirty || form.replacementFleetCostPerActuator.touched)) {
                        <span class="text-danger-show"
                          >
                        {{'common.value_cal_repFleetCostPerActuator_valMsg'|cxTranslate}}</span>
                      }
                    </div>
                    <div class="col-4 col-sm-5 EndaTooltip">
                      {{ 'common.text_smartire_usd' | cxTranslate }}
                      <mat-dialog-actions>
                        <span
                          (click)="endasureService.openTootlip( 'common.value_calculator_replacementFleetCostPerActuator', 'common.value_calculator_replacementFleetCostPerActuator_toolTip' )"
                          class="btn-link">
                          <img src="/icons/question_dark_kb.svg" alt="endasure-replacement-cost">
                        </span>
                      </mat-dialog-actions>
                    </div>
                  </div>
                </div>
                <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 ">
                  <label class="form-label" for="laborToInstallActuator">
                  {{ 'common.value_calculator_laborToInstallActuator' | cxTranslate }}*</label>
                  <div class="row col-12">
                    <div class="col-8 col-sm-6 pr-0 pl-0">
                      <input type="number" formControlName="laborToInstallActuator" (keypress)="calculateAndSetSum()" />
                      @if (form.laborToInstallActuator.invalid && (form.laborToInstallActuator.dirty || form.laborToInstallActuator.touched)) {
                        <span class="text-danger-show"
                          >
                        {{'common.value_cal_laborToInstallActuator_valMsg'|cxTranslate}}</span>
                      }
                    </div>
                    <div class="col-4 col-sm-5 EndaTooltip">
                      {{ 'common.text_smartire_usd' | cxTranslate }}
                      <mat-dialog-actions>
                      <span (click)="endasureService.openTootlip( 'common.value_calculator_laborToInstallActuator',
                       'common.value_calculator_laborToInstallActuator_toolTip' )" class="btn-link">
                          <img src="/icons/question_dark_kb.svg" alt="endasure-replacement-cost">
                        </span>
                      </mat-dialog-actions>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 ">
                  <label class="form-label" for="totalCostPerFailedActuator">
                  {{ 'common.value_calculator_totalCostPerFailedActuator' | cxTranslate }}</label>
                  <div class="row col-12">
                    <div class="col-8 col-sm-6 pr-0 pl-0">
                      <input type="number" formControlName="totalCostPerFailedActuator" [readOnly]="true" />
                    </div>
                    <div class="col-4 col-sm-5 EndaTooltip">
                      {{ 'common.text_smartire_usd' | cxTranslate }}
                    </div>
                  </div>
                </div>
                <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 ">
                  <label class="form-label" for="numberOfActuatorsReplacedPerYear">
                  {{ 'common.value_calculator_numberOfActuatorsReplacedPerYear' | cxTranslate }}*</label>
                  <div class="row col-12">
                    <div class="col-8 col-sm-6 pr-0 pl-0">
                      <input type="number" formControlName="numberOfActuatorsReplacedPerYear" />
                      @if (form.numberOfActuatorsReplacedPerYear.invalid && (form.numberOfActuatorsReplacedPerYear.dirty || form.numberOfActuatorsReplacedPerYear.touched)) {
                        <span class="text-danger-show"
                          >
                        {{'common.value_cal_noOfActuatorsReplacedPerYear_valMsg'|cxTranslate}}</span>
                      }
                    </div>
                    <div class="col-4 col-sm-5 EndaTooltip">
                      {{ 'common.value_calculator_actuator_text' | cxTranslate }}
                      <mat-dialog-actions>
                      <span (click)="endasureService.openTootlip( 'common.value_calculator_numberOfActuatorsReplacedPerYear',
                       'common.value_calculator_numberOfActuatorsReplacedPerYear_toolTip1',
                       'common.value_calculator_numberOfActuatorsReplacedPerYear_toolTip2' )" class="btn-link">
                          <img src="/icons/question_dark_kb.svg" alt="endasure-replacement-cost">
                        </span>
                      </mat-dialog-actions>
                    </div>
                  </div>
                </div>
              </div>
              <div class="airdisk-button-block">
                <button type="button" class="btn btn-primary endaSureBack visitorInfoNext yellow-btn"
                  (click)="endaSureBack()"><img src="/icons/link-right-white.svg" class="right-arrow" alt="">
                {{ 'common.value_calculator_back_button' | cxTranslate }}</button>
                <button type="button" class="btn btn-primary endaSureNxt visitorInfoNext yellow-btn"
                  (click)="endaSureNxt()">{{ 'common.value_calculator_next_button' | cxTranslate }}
                  <img src="/icons/link-right-white.svg" class="right-arrow" alt=""></button>
                </div>
              </div>
            </div>
          </form>
        }
      </div>
    </div>